// src/services/sales/QuotationService.ts

import { quotationApi } from "../../api";

const QuotationService = {

    /**
     * 🚀 Inicializar cotización
     * POST /api/quotations/initialize
     */
    initialize: async (data: any) => {

        const response =
            await quotationApi.addCustom(
                "/initialize",
                data
            );

        return response.data;

    },

    /**
 * 🧾 Actualizar encabezado cotización
 * PUT /api/quotations/{quotationId}/header
 */
    updateHeader: async (
        quotationId: number,
        data: any
    ) => {

        const response =
            await quotationApi.modifyCustom(
                `/${quotationId}/header`,
                data
            );

        return response.data;

    },

    /**
     * 🎯 Aplicar descuento global
     * PUT /api/quotations/{quotationId}/discount
     */
    applyDiscount: async (
        quotationId: number,
        data: {
            discountPercent: number;
            confirmReplaceManualDiscounts?: boolean;
            target?: 'PRODUCTS' | 'TOTAL';
        }
    ) => {

        const response =
            await quotationApi.modifyCustom(
                `/${quotationId}/discount`,
                data
            );

        return response.data;

    },

    /**
     * Elimina el descuento global de la cotización.
     * DELETE /api/quotations/{quotationId}/discount
     */
    removeDiscount: async (quotationId: number) => {

        const response =
            await quotationApi.removeCustom(
                `/${quotationId}/discount`
            );

        return response.data;

    },

    /**
     * 📄 Completar cotización
     * POST /api/quotations/{quotationId}/complete
     */
    create: async (
        quotationId: number,
        data: any
    ) => {

        const response =
            await quotationApi.addCustom(
                `/${quotationId}/complete`,
                data
            );

        return response.data;

    },

    /**
     * ✏️ Actualizar cotización
     * PUT /api/quotations/{quotationId}
     */
    update: async (
        quotationId: number,
        data: any
    ) => {

        const response =
            await quotationApi.modify(
                quotationId,
                data
            );

        return response.data;

    },

    /**
     * 🔥 Procesar cotización → convertir a venta
     * POST /api/quotations/{quotationId}/process
     */
    process: async (
        quotationId: number,
        data: {
            documentTypeId: number;
        }
    ) => {

        const response =
            await quotationApi.addCustom(
                `/${quotationId}/process`,
                data
            );

        return response.data;

    },

    /**
     * ❌ Cancelar cotización
     * DELETE /api/quotations/{quotationId}
     */
    cancel: async (
        quotationId: number
    ) => {

        const response =
            await quotationApi.remove(
                quotationId
            );

        return response.data;

    },

    /**
     * ❌ Cancelar cotización activa
     * DELETE /api/quotations/{quotationId}/active
     */
    cancelActive: async (
        quotationId: number
    ) => {

        const response =
            await quotationApi.removeCustom(
                `/${quotationId}/active`
            );

        return response.data;

    },

    /**
     * 🔍 Obtener detalle
     * GET /api/quotations/{quotationId}
     */
    findById: async (
        quotationId: number
    ) => {

        const response =
            await quotationApi.fetchById(
                quotationId
            );

        return response.data;

    },

    /**
     * 📝 Obtener cotizaciones pendientes
     * GET /api/quotations/pending
     */
    getPendingQuotations: async () => {

        const response =
            await quotationApi.fetchCustom(
                '/pending'
            );

        return response.data;

    },

    /**
     * 📚 Obtener historial de cotizaciones
     * GET /api/quotations/history
     */
    getQuotationHistory: async () => {

        const response =
            await quotationApi.fetchCustom(
                '/history'
            );

        return response.data;

    },

    /**
     * 📋 Buscar cotizaciones
     * POST /api/quotations/search
     */
    search: async (
        filters: any
    ) => {

        const response =
            await quotationApi.addCustom(
                "/search",
                filters
            );

        return response.data;

    },

};

export default QuotationService;